document.addEventListener("DOMContentLoaded", function(e) {
    // Usage of the IoNav
    let ionav = new IoNav({
        // buttonTarget: document.querySelector("#header"),
        elements: "#header > .logo-main, .nav-main",
        elementsNav: ".ionav-canvas .ionav-nav-main",
        linkSubmenuClickable: false,
        activeClassToggleOthers: true, // Only one active element is possible at the same time
        mqlQuery: {
            minWidth: "0px",
            maxWidth: "1030px"
        },
        debug: false
    });

    const navpoints = document.querySelectorAll(".submenu-layout-grid-image>a");
    navpoints.forEach(function(nav) {
        nav.href = "#";
    });

});
